import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

interface NavigationLinkProps {
    title: string;
    link: string;
    active?: boolean;
}

export const NavigationLink = ({ title, link, active = false }: NavigationLinkProps) => {
    return (
        <li role="presentation" className={active ? 'active' : ''}>
            <Link to={link}>{title}</Link>
        </li>
    );
};

NavigationLink.propTypes = {
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    active: PropTypes.bool
};
